import React, { useMemo } from "react";
import { useHistory } from "react-router-dom";

import styles from "./index.module.scss";
import { IMainRecords } from "../../../types";
import { reportUserBehavior } from "../../../../../utils/common";
import useGetCh from "../../../../../hooks/useGetCh";
import {
  SALES_GRAY_STATUS,
  SALES_GREEN_STATUS,
  SALES_ORANGE_STATUS,
  SERVICE_GRAY_STATUS,
  SERVICE_GREEN_STATUS,
  SERVICE_ORANGE_STATUS
} from "../../../constant";
import moment from "moment";

interface PropsType {
  content: IMainRecords;
}

export default function RecordItem(props: PropsType) {
  const { content } = props;
  let history = useHistory();
  const ch = useGetCh();

  /**判断是否精品购买 */
  const isSale = useMemo(() => {
    return content?.orderType > 1;
  }, [content]);

  const statusClassName = useMemo(() => {
    const greenList: any[] = isSale ? SALES_GREEN_STATUS : SERVICE_GREEN_STATUS;
    const orangeList: any[] = isSale
      ? SALES_ORANGE_STATUS
      : SERVICE_ORANGE_STATUS;
    const grayList: any[] = isSale ? SALES_GRAY_STATUS : SERVICE_GRAY_STATUS;
    const status = content?.orderStatus;

    if (greenList.includes(status)) {
      return styles.greenOrderStatus;
    } else if (orangeList.includes(status)) {
      return styles.orangeOrderStatus;
    } else if (grayList.includes(status)) {
      return styles.grayOrderStatus;
    } else {
      return styles.baseOrderStatus;
    }
  }, [content, isSale]);

  function navigateToSubList(uuid: string) {
    let url = "";
    let pa = "";
    let mcode = "";
    if (isSale) {
      //已取消不允许跳转
      if (content?.orderStatus === 4) {
        return;
      }
      mcode = "sub_order_list__click_to_settlement_detail";
      pa = `detail_page=外销结算单\`salesSettlementCode=${content.orderCode}`;
      url = `/serviceOrders/orderDetail/salesSettlementDetail?salesSettlementCode=${content.orderCode}`;
    } else {
      mcode = "main_order_list__click_to_sub_list";
      pa = `event=跳转到子单记录\`uuid=${content.orderCode}`;
      url = `/serviceOrders/subOrderList?serviceOrderUuid=${content.orderCode}`;
    }
    reportUserBehavior({
      so: "J001002",
      mcode,
      ch,
      pa
    });
    setTimeout(() => {
      history.push(url);
    }, 300);
    console.log(uuid, "服务单的uuid");
  }

  function navigateToAction(e, content, action) {
    //一般用在鼠标或键盘事件上
    if (e && e.stopPropagation) {
      //W3C取消冒泡事件
      e.stopPropagation();
    } else if (e && window.event) {
      //IE取消冒泡事件
      window.event.cancelBubble = true;
    }

    console.log("根据不同的action 跳转到对应的签名页面", action.url);
    reportUserBehavior({
      so: "J001002",
      mcode: "main_order_list__click_to_action",
      ch,
      pa: `subOrderTypeText=${content?.subOrderTypeText}\`url=${action.url}\`desc=${action.desc}`
    });

    setTimeout(() => {
      window.open(action.url, "_self");
    }, 300);
  }

  const cellTitle = useMemo(() => {
    return isSale ? "精品购买" : "维保服务";
  }, [isSale]);

  const isClosed = useMemo(() => {
    //精品单已取消=4 服务单已取消=9
    return isSale ? content.orderStatus === 4 : content?.orderStatus === 9;
  }, [content, isSale]);

  return (
    <div
      className={isClosed ? styles.closedCard : styles.card}
      onClick={() => navigateToSubList(content?.uuid)}
    >
      <div className={[styles.cellWapper, styles.mainOrderTypeText].join(" ")}>
        <div className={styles.cellTitle}>
          <h3>{cellTitle}</h3>
        </div>
        <div className={statusClassName}>{content?.orderStatusName}</div>
      </div>
      <div className={styles.cellWapper}>
        <div className={styles.cellTitle}>服务地点</div>
        <div className={styles.cellContent}>{content?.shopName}</div>
      </div>
      <div className={styles.cellWapper}>
        <div className={styles.cellTitle}>{content?.orderStageName}</div>
        <div className={styles.cellContent}>
          {moment(content?.serviceTime as any).format("YYYY/MM/DD HH:mm")}
        </div>
      </div>
      {isSale && (
        <div className={styles.cellWapper}>
          <div className={styles.cellTitle}>结算金额</div>
          <div className={styles.cellContent}>{content?.payAmount}</div>
        </div>
      )}

      {content?.actions?.length > 0 && (
        <div className={styles.actionWrapper}>
          {content?.actions?.map((item, index) => {
            return (
              <div className={styles.actionItem} key={index}>
                <span className={styles.desc}>{item.desc}</span>
                <div
                  className={styles.btn}
                  onClick={(e) => {
                    navigateToAction(e, content, item);
                  }}
                >
                  {item.text}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
